import { postJson } from "./http";
import type { ZohoStepDTO } from "./zohoConnectApi";

/**
 * Setting up Tally. `look` starts a fresh read of Sales and Purchase numbering.
 * Polls pass false so a visit does not restart the jobs it is waiting on.
 */
export interface TallyPrepareStateDTO {
  steps: ZohoStepDTO[];
}

export const runTallyPrepare = async (publicId: string, look: boolean): Promise<TallyPrepareStateDTO> =>
  (
    await postJson<{ success: boolean; message: string; data: TallyPrepareStateDTO }>(
      "/api/onboarding/tally/prepare",
      { public_id: publicId, look }
    )
  ).data;
